var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1647_18157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 32,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_18157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5893 27.756H41.588L38.0018 27.7498C38.0015 27.7498 38.0012 27.7498 38.0009 27.7498L38.0005 27.7498L38.0018 26.9998C37.4518 26.9998 37.0018 26.5498 37.0018 25.9998V22.4123C37.0018 22.1498 37.108 21.8935 37.2955 21.706L41.2893 17.7123C41.7955 17.206 41.6143 16.3498 40.9143 16.1998L41.5893 27.756ZM41.5893 27.756C42.052 27.756 42.4986 27.5699 42.8259 27.2426L46.8196 23.2489C46.8866 23.1819 46.9607 23.1728 47.0077 23.1838C47.0303 23.1891 47.0421 23.1979 47.0473 23.203C47.0503 23.206 47.0611 23.2166 47.0684 23.2507C47.1885 23.8112 47.2518 24.3961 47.2518 24.9998C47.2518 28.1186 45.5174 30.8368 42.9599 32.241L42.3634 31.6444C40.5171 29.7982 37.9535 29.1017 35.5724 29.5598L30.7557 24.743C30.8915 20.3072 34.5331 16.7498 39.0018 16.7498C39.6049 16.7498 40.1899 16.8129 40.7576 16.9332L41.5893 27.756ZM20.4534 16.904L20.4573 16.907L26.9573 21.9008L26.9594 21.9024C27.143 22.0424 27.2518 22.2598 27.2518 22.4935V25.8748V26.1854L27.4714 26.4051L34.2839 33.2176L34.6684 33.6021L35.1534 33.3562C36.6851 32.5798 38.6075 32.8349 39.8839 34.1114L46.8839 41.1114C47.3723 41.5997 47.3723 42.3936 46.8839 42.8819L42.8839 46.8819C42.3956 47.3703 41.6017 47.3703 41.1134 46.8819L34.1134 39.8819L34.1123 39.8809C32.832 38.6058 32.5811 36.6846 33.3582 35.1514L33.6041 34.6664L33.2196 34.2819L26.4071 27.4694L26.1874 27.2498H25.8768H22.4955C22.2663 27.2498 22.0434 27.1397 21.9044 26.9574L21.9025 26.955L16.905 20.4583C16.9047 20.4578 16.9043 20.4574 16.904 20.4569C16.675 20.1543 16.7051 19.7321 16.9696 19.4676L19.4678 16.9694C19.7424 16.6992 20.1629 16.6777 20.4534 16.904ZM17.7759 41.2864L17.776 41.2862L26.5269 32.5294L29.5622 35.5646C29.3315 36.7681 29.3937 38.0127 29.7491 39.1918L22.7152 46.2257C22.0616 46.8793 21.1709 47.2498 20.2455 47.2498C18.316 47.2498 16.7518 45.6856 16.7518 43.756C16.7518 42.8307 17.1222 41.94 17.7759 41.2864ZM19.4108 41.4088C18.9888 41.8307 18.7518 42.403 18.7518 42.9998C18.7518 43.5965 18.9888 44.1688 19.4108 44.5908C19.8327 45.0127 20.405 45.2498 21.0018 45.2498C21.5985 45.2498 22.1708 45.0127 22.5928 44.5908C23.0147 44.1688 23.2518 43.5965 23.2518 42.9998C23.2518 42.403 23.0147 41.8307 22.5928 41.4088C22.1708 40.9868 21.5985 40.7498 21.0018 40.7498C20.405 40.7498 19.8327 40.9868 19.4108 41.4088Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1647_18157",
    x: -3.6,
    y: -3.53945,
    width: 71.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1647_18157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1647_18157",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_18157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteService);
export default __webpack_public_path__ + "static/media/white_service.48224c082bbe90de26593928f9daebce.svg";
export { ForwardRef as ReactComponent };